import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasySupplierRelatedTranslations = wrapTranslationsSchema({
	name: 'BuyEasySupplierRelatedTranslations',
	title: 'Related Section Translations',
	sanityId: 'buyeasy-supplierRelated',
	fields: {
		relatedSuppliersSectionNoRelatedSuppliers: 'No related suppliers available',
		relatedSuppliersSectionTitle: 'RELATED SUPPLIERS',
		relatedSuppliersSectionCountry: 'Country',
		relatedSuppliersSectionCity: 'City',
	},
});
